// Sample
// export const XXX = 'XXX';

// 獲取 prdPageBrandStyle：區分 元鍋John‘s 和 MMM 商品頁的變數
export const MID_GET_PRD_PAGE_BRAND_STYLE = 'MID_GET_PRD_PAGE_BRAND_STYLE';

// 獲取 MMM 廣告
export const MID_GET_MMM_HOME_ADV = 'MID_GET_MMM_HOME_ADV';
export const MID_GET_ZH_MMM_SAUCE_ADV = 'MID_GET_ZH_MMM_SAUCE_ADV';
export const MID_GET_ZH_MMM_NOODLES_ADV = 'MID_GET_ZH_MMM_NOODLES_ADV';
export const MID_GET_ZH_MMM_VIDEOS_ADV = 'MID_GET_ZH_MMM_VIDEOS_ADV';

// 獲取 元鍋John's 廣告
export const MID_GET_JOHNS_HOME_ADV = 'MID_GET_JOHNS_HOME_ADV';

// 獲取正和廣告
export const MID_GET_ZHHOME_ADV = 'MID_GET_ZHHOME_ADV';
export const MID_GET_ZHNOODLES_ADV = 'MID_GET_ZHNOODLES_ADV';
export const MID_GET_ZHSAUCE_ADV = 'MID_GET_ZHSAUCE_ADV';
export const MID_GET_ZHEVALUATE_ADV = 'MID_GET_ZHEVALUATE_ADV';

// 首頁
export const MID_GET_NEW_INDEX_DATA = 'MID_GET_NEW_INDEX_DATA';
export const MID_GET_HOME_PRODUCTS = 'MID_GET_HOME_PRODUCTS';

export const MID_GET_INDEX_MINICART = 'MID_GET_INDEX_MINICART';
export const MID_GET_INDEX_MEMBERPOINTS = 'MID_GET_INDEX_MEMBERPOINTS';

// 總覽頁面
export const MID_GET_CLASSIC_PRODUCTS = 'MID_GET_CLASSIC_PRODUCTS';
export const MID_GET_REAL_PRODUCTS = 'MID_GET_REAL_PRODUCTS';
export const MID_GET_GIFT_PRODUCTS = 'MID_GET_GIFT_PRODUCTS';
export const MID_GET_PRODUCTS = 'MID_GET_PRODUCTS';

// login
export const MID_SUBMIT_LOGIN_DATA = 'MID_SUBMIT_LOGIN_DATA';

// 註冊相關
export const MID_SUBMIT_REGISTER_DATA = 'MID_SUBMIT_REGISTER_DATA';
// 獲取手機驗證碼
export const MID_GET_PHONE_CODE = 'MID_GET_PHONE_CODE';

/** 購物車-步驟二 */
// 獲取地址簿信息List
export const MID_GET_ADDRESS_BOOK = 'MID_GET_ADDRESS_BOOK';
// 提交訂購相關信息
export const MID_POST_PLACE_ORDER = 'MID_POST_PLACE_ORDER';

/** 購物車 - 步驟三 - 完成訂購 */
// 別人也買了商品信息
export const MID_UPDATE_TRPLUS_OTHERALSOLIKEPRODUCT = 'MID_UPDATE_TRPLUS_OTHERALSOLIKEPRODUCT';

// 订单相关
export const MID_GET_ORDER_LIST_DATA = 'MID_GET_ORDER_LIST_DATA';
export const MID_GET_ORDER_LIST_DETAIL_DATA = 'MID_GET_ORDER_LIST_DETAIL_DATA';
export const MID_GET_ORDER_LIST_ADVERTISEMENT = 'MID_GET_ORDER_LIST_ADVERTISEMENT';

// 折扣卷相关
export const MID_UPDATE_IS_SHOW_COUPON_LIST_MODAL = 'MID_UPDATE_IS_SHOW_COUPON_LIST_MODAL';

// 购物车相关
export const MID_GET_CART_LIST_DATA = 'MID_GET_CART_LIST_DATA';
export const MID_POST_UPDATE_CART = 'MID_POST_UPDATE_CART';
export const MID_POST_USE_COUPON_CODE = 'MID_POST_USE_COUPON_CODE';

/** 產品頁 相關 */
// 獲取產品信息
export const MID_GET_PRODUCT_DATA = 'MID_GET_PRODUCT_DATA';
export const MID_ADD_TO_CART = 'MID_ADD_TO_CART';
// 加入購物車
export const MID_POST_ADD_TO_CART_FOR_PRODUCT_PAGE = 'MID_POST_ADD_TO_CART_FOR_PRODUCT_PAGE';
// 加入最愛
export const MID_ADD_TO_FAVORITE = 'MID_ADD_TO_FAVORITE';
// 取消最愛
export const MID_REMOVE_TO_FAVORITE = 'MID_REMOVE_TO_FAVORITE';
// 提交評價信息
export const MID_POST_ADD_WRITE_REVIEW = 'MID_POST_ADD_WRITE_REVIEW';
// export const MID_GET_POINT_OF_SERVICES = 'MID_GET_POINT_OF_SERVICES';
// export const MID_GET_COUPON_LIST_FOR_PRODUCT = 'MID_GET_COUPON_LIST_FOR_PRODUCT';
// export const MID_UPDATE_SIMPLEPRODUCTLIST = 'MID_UPDATE_SIMPLEPRODUCTLIST';
// export const MID_DELETE_BROWSERPRODUCT = 'MID_DELETE_BROWSERPRODUCT';
// export const MID_DELETE_ALL_BROWSERPRODUCT = 'MID_DELETE_ALL_BROWSERPRODUCT';
// export const MID_ADD_PRODUCT_ARRIVAL_NOTICE = 'MID_ADD_PRODUCT_ARRIVAL_NOTICE';
// export const MID_REMOVE_PRODUCT_ARRIVAL_NOTICE = 'MID_REMOVE_PRODUCT_ARRIVAL_NOTICE';
// 立即結帳
export const MID_POST_INSTANT_ADD_TO_CART_FOR_PRODUCT_PAGE = 'MID_POST_INSTANT_ADD_TO_CART_FOR_PRODUCT_PAGE';

// 取得訂單詳細頁資料
export const MID_GET_ORDER_DETAIL_DATA = 'MID_GET_ORDER_DETAIL_DATA';
export const MID_POST_CHECK_REFRESH_ORDER = 'MID_POST_CHECK_REFRESH_ORDER';
export const MID_POST_CHECK_RETURN_ENTRYNUMBERS = 'MID_POST_CHECK_RETURN_ENTRYNUMBERS';
export const MID_POST_ORDER_RETURN = 'MID_POST_ORDER_RETURN';
export const MID_UPDATE_RETURN_BANKID = 'MID_UPDATE_RETURN_BANKID';
export const MID_GET_RETURN_REQUESTB2B = 'MID_GET_RETURN_REQUESTB2B';
